// extracted by mini-css-extract-plugin
export default {"noSubscriptions":"NoSubscriptions_noSubscriptions__qDbjQ"};